import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutProhibitedTable extends Layout {
    sourceProhibited: DataSource;
    tableProhibited: Table;
}
